import styled from 'styled-components';

export const DepartmentSelectorContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.verdigris};
  border-radius: ${({ theme }) => theme.radius.m};
`;

export const DepartmentSelectorTitle = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.verdigrisDark};
  background-color: ${({ theme }) => theme.colors.mintCream};
  border-top-left-radius: ${({ theme }) => theme.radius.m};
  border-top-right-radius: ${({ theme }) => theme.radius.m};
  border-bottom-left-radius: ${({ theme, isOpen }) =>
    isOpen ? '0 !important' : theme.radius.m};
  border-bottom-right-radius: ${({ theme, isOpen }) =>
    isOpen ? '0 !important' : theme.radius.m};
  padding-left: ${({ theme }) => theme.spacing.m};
  padding-right: ${({ theme }) => theme.spacing.m};
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${({ theme }) => theme.height.h6};
`;

export const DepartmentSelectorOptions = styled.div`
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  width: ${({ theme }) => theme.width.full};
  height: ${({ theme, isOpen }) => (isOpen ? theme.height.full : '0')};
  border-radius: 0 ${({ theme }) => theme.radius.m};
  padding: ${({ theme }) => theme.spacing.xs} 0;
`;

export const StatsIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.s};
`;
